import type { ReactNode } from 'react';

type SplitWorkspaceRailMode = 'inline' | 'fixed';

export function SplitWorkspaceLayout({
  main,
  rail,
  railPosition = 'end',
  railMode = 'inline'
}: {
  main: ReactNode;
  rail?: ReactNode;
  railPosition?: 'start' | 'end';
  railMode?: SplitWorkspaceRailMode;
}): JSX.Element {
  const railClassName = [
    'av-split-workspace__rail',
    railMode === 'fixed' ? 'av-split-workspace__rail--fixed' : '',
    railPosition === 'start' ? 'av-split-workspace__rail--start' : 'av-split-workspace__rail--end'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={[
        'av-split-workspace',
        rail ? 'has-rail' : '',
        rail && railMode === 'fixed' ? 'has-fixed-rail' : '',
        railPosition === 'start' ? 'is-rail-start' : 'is-rail-end'
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {rail && railPosition === 'start' ? <aside className={railClassName}>{rail}</aside> : null}
      <div className="av-split-workspace__main">{main}</div>
      {rail && railPosition === 'end' ? <aside className={railClassName}>{rail}</aside> : null}
    </div>
  );
}
